/* eslint-disable jsx-a11y/anchor-is-valid */
import clsx from 'clsx'
import {FC} from 'react'
import {toAbsoluteUrl} from '../../../../../../../_metronic/helpers'
import {Trigger} from '../../core/_models'

type Props = {
  trigger: Trigger
}

const UserInfoCell: FC<Props> = ({trigger}) => (
  <div className='d-flex align-items-center'>
    {/* begin:: Avatar */}
    <div className='symbol symbol-circle symbol-40px overflow-hidden me-3'>
      <a href='#'>
        <div className='symbol-label'>
          <img
            src={toAbsoluteUrl(`/media/svg/customicons/icons8-trigger-32.png`)}
            className='w-50'
          />
        </div>
      </a>
    </div>
    <div>

    <div className='d-flex flex-column'>{trigger.keyword}</div>
    <div className='line-clamp'>{ trigger.description}</div>
    </div>

  </div>
)

export {UserInfoCell}
